/**
 * @file loading-overlay.js
 * @description Componente overlay de loading (CRA)
 */

import React from "react"
import { Loader2 } from "lucide-react"
import { useLoading } from "../hooks/use-loading.js"

/**
 * Componente overlay de loading
 * @returns {React.ReactElement} Overlay de loading
 */
export function LoadingOverlay() {
  const { isLoading, loadingMessage } = useLoading()

  if (!isLoading) return null

  return React.createElement(
    "div",
    {
      className:
        "fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm",
    },
    React.createElement(
      "div",
      {
        className:
          "p-8 flex flex-col items-center gap-4 min-w-[200px] min-h-[200px]",
      },
      React.createElement(
        "p",
        { className: "text-sm font-medium text-white text-center" },
        loadingMessage
      ),
      React.createElement(Loader2, {
        className: "h-16 w-16 animate-spin text-blue-500",
      })
    )
  )
}
